$(document).ready(function () {
    const video = document.getElementById('landing-video');
    if(video) {
        const playButton = $('.fa-circle-play.position-absolute');
        $('.fa-circle-play.position-absolute, #landing-video').click(function () {
            if (playButton.hasClass('d-block')) {
                video.play();
                playButton.addClass('d-none').removeClass('d-block');
            } else {
                video.pause()
                playButton.addClass('d-block').removeClass('d-none');
            }
        });
    }
});